import React from "react";

export const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2 1.5L8 5L2 8.5V1.5Z" fill="#002E19"/>
  </svg>
);
